module.exports = require('./helpers/bundle-url').getBundleURL('cG8j0') + "logo.c51670a8.svg";